export default {
  default: '0 5px 10px 0 rgba(0,0,0,0.05)',
  dark: '0 3px 10px 0 rgba(0,0,0,0.2)',
  message: '0 1px 3px 0 rgba(0,0,0,.06667)',
  row: '0px 2px 0px 0px rgba(0,0,0,0.05)',
  switch: '0 3px 6px 0 rgba(0,0,0,.15)',
};
